import { Button, DialogActions, DialogContent, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import DialogHeader from "../../../components/Dialog/DialogHeader";
import UserDialog from "../../../components/Dialog/UserDialog";
import { XpSourceDict } from "../../../model/Dto/Dict/XpSource";

interface XpSourceDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (data: { name: string }) => Promise<boolean>;
    initialData?: XpSourceDict | null;
    title: string;
}

export default function XpSourceDialog({ open, onClose, onSave, initialData, title }: XpSourceDialogProps) {
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setName(initialData?.name ?? "");
    }, [initialData, open]);

    const handleSave = async () => {
        if (!name.trim()) return;
        setLoading(true);
        const success = await onSave({ name: name.trim() });
        setLoading(false);
        if (success) onClose();
    };

    return (
        <UserDialog handleClose={onClose} open={open} maxWidth="sm">
            <DialogHeader loading={loading} title={title} />
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 2 }}>
                    <TextField
                        autoFocus
                        label="Название"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        disabled={loading}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Отмена</Button>
                <Button onClick={handleSave} variant="contained" disabled={loading || !name.trim()}>
                    {loading ? "Сохранение..." : "Сохранить"}
                </Button>
            </DialogActions>
        </UserDialog>
    );
}
